
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire37b7"];
var parcelRegister = parcelRequire.register;
parcelRegister("8iEgn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $60af3c968af4b9f4$export$2e2bcd8739ae039; });

var $91i6m = parcelRequire("91i6m");

var $4ON8O = parcelRequire("4ON8O");

var $9X0U9 = parcelRequire("9X0U9");
var $TJrLs = parcelRequire("TJrLs");
var $ijE2m = parcelRequire("ijE2m");
var $jrqUM = parcelRequire("jrqUM");
var $lBrex = parcelRequire("lBrex");

var $1fll9 = parcelRequire("1fll9");
var $60af3c968af4b9f4$var$sectionMessageStyles = (0, $lBrex.xcss)({
    wordBreak: "break-word",
    borderRadius: "border.radius"
});
var $60af3c968af4b9f4$var$bleedStyles = (0, $lBrex.xcss)({
    display: "flex",
    marginBlock: "space.negative.025"
});
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ var $60af3c968af4b9f4$var$SectionMessage = /*#__PURE__*/ (0, $91i6m.forwardRef)(function SectionMessage(_ref, ref) {
    var children = _ref.children, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "information" : _ref$appearance, actions = _ref.actions, title = _ref.title, icon = _ref.icon, testId = _ref.testId;
    var _getAppearanceIconSty = (0, $1fll9.getAppearanceIconStyles)(appearance, icon), primaryColor = _getAppearanceIconSty.primaryIconColor, secondaryColor = _getAppearanceIconSty.backgroundColor, Icon = _getAppearanceIconSty.Icon;
    var actionElements = actions && actions.type === (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).Fragment ? actions.props.children : actions;
    var actionsArray = (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).Children.toArray(actionElements);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $9X0U9.default), {
        as: "section",
        backgroundColor: $60af3c968af4b9f4$var$appearanceMap[appearance],
        padding: "space.200",
        testId: testId,
        ref: ref,
        xcss: $60af3c968af4b9f4$var$sectionMessageStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $TJrLs.default), {
        space: "space.200",
        alignBlock: "stretch"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $9X0U9.default), {
        xcss: $60af3c968af4b9f4$var$bleedStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(Icon, {
        size: "medium",
        primaryColor: primaryColor,
        secondaryColor: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $ijE2m.default), {
        space: "space.100",
        testId: testId && "".concat(testId, "--content")
    }, !!title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $4ON8O.default), {
        as: "h2",
        level: "h500"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $jrqUM.default), null, children), actionsArray.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement((0, $TJrLs.default), {
        shouldWrap: true,
        testId: testId && "".concat(testId, "--actions"),
        separator: "\xb7",
        space: "space.100",
        rowSpace: "space.0"
    }, actionsArray))));
});
var $60af3c968af4b9f4$var$appearanceMap = {
    information: "color.background.information",
    warning: "color.background.warning",
    error: "color.background.danger",
    success: "color.background.success",
    discovery: "color.background.discovery"
};
$60af3c968af4b9f4$var$SectionMessage.displayName = "SectionMessage";
var $60af3c968af4b9f4$export$2e2bcd8739ae039 = $60af3c968af4b9f4$var$SectionMessage;

});
parcelRegister("4ON8O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3821f35411a14a63$export$2e2bcd8739ae039; });

var $cIDQN = parcelRequire("cIDQN");

var $ai2Md = parcelRequire("ai2Md");

var $5YM7L = parcelRequire("5YM7L");

var $lPOF7 = parcelRequire("lPOF7");

var $7n972 = parcelRequire("7n972");

var $c4OEa = parcelRequire("c4OEa");

var $e08gr = parcelRequire("e08gr");
var $3821f35411a14a63$var$_excluded = [
    "level"
];
// https://atlassian.design/foundations/typography
var $3821f35411a14a63$var$levelMap = {
    h900: "h1",
    h800: "h1",
    h700: "h2",
    h600: "h3",
    h500: "h4",
    h400: "h5",
    h300: "h6",
    // NB: These two levels are not covered at all by the existing @atlaskit/css-reset
    h200: "div",
    h100: "div"
};
var $3821f35411a14a63$var$headingResetStyles = (0, $lPOF7.css)({
    color: "var(--ds-text, #172B4D)",
    marginBlock: "var(--ds-space-0, 0px)"
});
var $3821f35411a14a63$var$h900Styles = (0, $lPOF7.css)({
    fontSize: "var(--ds-font-size-600, 35px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: "-0.01em",
    lineHeight: "var(--ds-font-lineHeight-600, 40px)"
});
var $3821f35411a14a63$var$h800Styles = (0, $lPOF7.css)({
    fontSize: "var(--ds-font-size-500, 29px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: "-0.01em",
    lineHeight: "var(--ds-font-lineHeight-500, 32px)"
});
var $3821f35411a14a63$var$h700Styles = (0, $lPOF7.css)({
    fontSize: "var(--ds-font-size-400, 24px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: "-0.01em",
    lineHeight: "var(--ds-font-lineHeight-400, 28px)"
});
var $3821f35411a14a63$var$h600Styles = (0, $lPOF7.css)({
    fontSize: "var(--ds-font-size-300, 20px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: "-0.008em",
    lineHeight: "var(--ds-font-lineHeight-300, 24px)"
});
var $3821f35411a14a63$var$h500Styles = (0, $lPOF7.css)({
    fontSize: "var(--ds-font-size-200, 16px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: "-0.006em",
    lineHeight: "var(--ds-font-lineHeight-200, 20px)"
});
var $3821f35411a14a63$var$h400Styles = (0, $lPOF7.css)({
    fontSize: "var(--ds-font-size-100, 14px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: "-0.003em",
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $3821f35411a14a63$var$h300Styles = (0, $lPOF7.css)({
    fontSize: "var(--ds-font-size-075, 12px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)",
    textTransform: "uppercase"
});
var $3821f35411a14a63$var$h200Styles = (0, $lPOF7.css)({
    fontSize: "var(--ds-font-size-075, 12px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $3821f35411a14a63$var$h100Styles = (0, $lPOF7.css)({
    fontSize: "var(--ds-font-size-050, 11px)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $3821f35411a14a63$var$inverseStyles = (0, $lPOF7.css)({
    color: "var(--ds-text-inverse, #FFF)"
});
var $3821f35411a14a63$var$subtlestStyles = (0, $lPOF7.css)({
    color: "var(--ds-text-subtlest, #6B778C)"
});
/**
 * __Heading__
 *
 * A heading is a typography component used to display text in different sizes and formats.
 *
 * @example
 *
 * ```jsx
 * import Heading from '@atlaskit/heading';
 *
 * const H100 = () => (
 *   <Heading level="h100">h100</Heading>
 * );
 * ```
 */ var $3821f35411a14a63$var$OldHeading = function OldHeading(_ref) {
    var children = _ref.children, level = _ref.level, id = _ref.id, testId = _ref.testId, as = _ref.as, _ref$color = _ref.color, color = _ref$color === void 0 ? "default" : _ref$color;
    typeof $e08gr;
    var _useHeading = (0, $7n972.useHeading)($3821f35411a14a63$var$levelMap[level]), _useHeading2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Markup = as || inferredElement;
    var isSubtleHeading = level === "h200" || level === "h100";
    var needsAriaRole = Markup === "div" && hLevel;
    return (0, $lPOF7.jsx)(Markup, {
        id: id,
        "data-testid": testId,
        role: needsAriaRole ? "heading" : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        css: [
            $3821f35411a14a63$var$headingResetStyles,
            level === "h100" && $3821f35411a14a63$var$h100Styles,
            level === "h200" && $3821f35411a14a63$var$h200Styles,
            level === "h300" && $3821f35411a14a63$var$h300Styles,
            level === "h400" && $3821f35411a14a63$var$h400Styles,
            level === "h500" && $3821f35411a14a63$var$h500Styles,
            level === "h600" && $3821f35411a14a63$var$h600Styles,
            level === "h700" && $3821f35411a14a63$var$h700Styles,
            level === "h800" && $3821f35411a14a63$var$h800Styles,
            level === "h900" && $3821f35411a14a63$var$h900Styles,
            color === "inverse" && $3821f35411a14a63$var$inverseStyles,
            color === "default" && isSubtleHeading && $3821f35411a14a63$var$subtlestStyles
        ]
    }, children);
};
/**
 * __Heading__
 *
 * A heading is a typography component used to display text in different sizes and formats.
 *
 * @example
 *
 * ```jsx
 * import Heading from '@atlaskit/heading';
 *
 * // New component
 * <Heading size="xxlarge">Page title</Heading>
 *
 * // Old component
 * const H100 = () => (
 *   <Heading level="h100">h100</Heading>
 * );
 * ```
 */ var $3821f35411a14a63$var$Heading = function Heading(_ref2) {
    var level = _ref2.level, props = (0, (/*@__PURE__*/$parcel$interopDefault($ai2Md)))(_ref2, $3821f35411a14a63$var$_excluded);
    return level ? // eslint-disable-next-line jsx-a11y/heading-has-content, @repo/internal/react/no-unsafe-spread-props
    (0, $lPOF7.jsx)($3821f35411a14a63$var$OldHeading, (0, (/*@__PURE__*/$parcel$interopDefault($cIDQN)))({
        level: level
    }, props)) : // eslint-disable-next-line jsx-a11y/heading-has-content, @repo/internal/react/no-unsafe-spread-props
    (0, $lPOF7.jsx)((0, $c4OEa.default), props);
};
var $3821f35411a14a63$export$2e2bcd8739ae039 = $3821f35411a14a63$var$Heading;

});
parcelRegister("7n972", function(module, exports) {

$parcel$export(module.exports, "useHeading", function () { return $55e1bff6ee8a733c$export$97a37b1befbbf9b1; });

var $91i6m = parcelRequire("91i6m");
// Allows support for heading levels 1-9 via aria-level
var $55e1bff6ee8a733c$var$HeadingLevelContext = /*#__PURE__*/ (0, $91i6m.createContext)(0);
var $55e1bff6ee8a733c$export$6a64a1e2d0bbbf75 = function useHeadingLevel() {
    return (0, $91i6m.useContext)($55e1bff6ee8a733c$var$HeadingLevelContext);
};
var $55e1bff6ee8a733c$export$97a37b1befbbf9b1 = function useHeading(fallback) {
    var hLevel = $55e1bff6ee8a733c$export$6a64a1e2d0bbbf75();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? "div" : "h".concat(hLevel)) || fallback
    ];
};
/**
 * __Heading level provider__
 *
 * The Heading level provider injects the heading level to all `Heading` components below it in the component tree.
 *
 * @example
 * ```tsx
 * // Will correctly infer the heading level
 * <HeadingContext value={1}>
 *  <Heading>H1</Heading>
 *  <HeadingContext>
 *    <Heading>H2</Heading>
 *  </HeadingContext>
 * </HeadingContext>
 * ```
 */ var $55e1bff6ee8a733c$var$HeadingLevelContextProvider = function HeadingLevelContextProvider(_ref) {
    var children = _ref.children, value = _ref.value;
    var parentHeadingLevel = $55e1bff6ee8a733c$export$6a64a1e2d0bbbf75();
    var headingLevel = parentHeadingLevel + 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement($55e1bff6ee8a733c$var$HeadingLevelContext.Provider, {
        value: value || headingLevel
    }, children);
};
var $55e1bff6ee8a733c$export$2e2bcd8739ae039 = $55e1bff6ee8a733c$var$HeadingLevelContextProvider;

});

parcelRegister("c4OEa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8cad2524638faa76$export$2e2bcd8739ae039; });

var $5YM7L = parcelRequire("5YM7L");

var $lPOF7 = parcelRequire("lPOF7");

var $7re4P = parcelRequire("7re4P");
var $3W7HL = parcelRequire("3W7HL");

var $7n972 = parcelRequire("7n972");

var $e08gr = parcelRequire("e08gr");
var $8cad2524638faa76$var$sizeTagMap = {
    xxlarge: "h1",
    xlarge: "h1",
    large: "h2",
    medium: "h3",
    small: "h4",
    xsmall: "h5",
    xxsmall: "h6"
};
var $8cad2524638faa76$var$headingResetStyles = (0, $lPOF7.css)({
    letterSpacing: "normal",
    marginBlock: 0,
    textTransform: "none"
});
var $8cad2524638faa76$var$useColor = function useColor(colorProp) {
    var surface = (0, $3W7HL.useSurface)();
    /**
   * Where the color of the surface is inverted we always override the color
   * as there is no valid choice that is not covered by the override.
   */ if ((0, $7re4P.inverseColorMap).hasOwnProperty(surface)) return (0, $7re4P.inverseColorMap)[surface];
    return colorProp || "color.text";
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ var $8cad2524638faa76$var$Heading = function Heading(_ref) {
    var children = _ref.children, size = _ref.size, id = _ref.id, testId = _ref.testId, as = _ref.as, colorProp = _ref.color;
    typeof $e08gr;
    // Technically size can be undefined here due to how the types work.
    // Once removing the level prop this assertion can be removed since size will be a required prop.
    var _useHeading = (0, $7n972.useHeading)($8cad2524638faa76$var$sizeTagMap[size]), _useHeading2 = (0, (/*@__PURE__*/$parcel$interopDefault($5YM7L)))(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Component = as || inferredElement;
    var needsAriaRole = Component === "div" && hLevel;
    var color = $8cad2524638faa76$var$useColor(colorProp);
    return (0, $lPOF7.jsx)(Component, {
        id: id,
        "data-testid": testId,
        role: needsAriaRole ? "heading" : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        css: [
            $8cad2524638faa76$var$headingResetStyles,
            size && $8cad2524638faa76$var$headingSizeStylesMap[size],
            $8cad2524638faa76$export$93e8ddd840a408f9[color]
        ]
    }, children);
};
var $8cad2524638faa76$export$93e8ddd840a408f9 = {
    "color.text": (0, $lPOF7.css)({
        color: "var(--ds-text, #172B4D)"
    }),
    "color.text.inverse": (0, $lPOF7.css)({
        color: "var(--ds-text-inverse, #FFFFFF)"
    }),
    "color.text.warning.inverse": (0, $lPOF7.css)({
        color: "var(--ds-text-warning-inverse, #172B4D)"
    })
};
/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::df829c6c0aa19bb57c0c77dc08d12d60>>
 * @codegenId typography
 * @codegenCommand yarn workspace @atlaskit/heading codegen
 */ var $8cad2524638faa76$var$headingSizeStylesMap = {
    xxlarge: (0, $lPOF7.css)({
        font: 'var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    xlarge: (0, $lPOF7.css)({
        font: 'var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    large: (0, $lPOF7.css)({
        font: 'var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    medium: (0, $lPOF7.css)({
        font: 'var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    small: (0, $lPOF7.css)({
        font: 'var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    xsmall: (0, $lPOF7.css)({
        font: 'var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    xxsmall: (0, $lPOF7.css)({
        font: 'var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    })
};
var /**
 * @codegenEnd
 */ $8cad2524638faa76$export$2e2bcd8739ae039 = $8cad2524638faa76$var$Heading;

});


parcelRegister("1fll9", function(module, exports) {

$parcel$export(module.exports, "getAppearanceIconStyles", function () { return $0e87bee448892c08$export$e9b82d2e21ac0c1f; });

var $dsN6L = parcelRequire("dsN6L");

var $91i6m = parcelRequire("91i6m");

var $1pjMo = parcelRequire("1pjMo");

var $daZRO = parcelRequire("daZRO");

var $1a5r2 = parcelRequire("1a5r2");

var $kjPIx = parcelRequire("kjPIx");

var $cOOAJ = parcelRequire("cOOAJ");

var $kLNLK = parcelRequire("kLNLK");
function $0e87bee448892c08$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0e87bee448892c08$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0e87bee448892c08$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($dsN6L)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0e87bee448892c08$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0e87bee448892c08$export$faa35441caff5bb6 = {
    information: {
        backgroundColor: "var(--ds-background-information, ".concat((0, $kLNLK.B50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($1a5r2))),
        primaryIconColor: "var(--ds-icon-information, ".concat((0, $kLNLK.B500), ")")
    },
    warning: {
        backgroundColor: "var(--ds-background-warning, ".concat((0, $kLNLK.Y50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($cOOAJ))),
        primaryIconColor: "var(--ds-icon-warning, ".concat((0, $kLNLK.Y500), ")")
    },
    error: {
        backgroundColor: "var(--ds-background-danger, ".concat((0, $kLNLK.R50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($daZRO))),
        primaryIconColor: "var(--ds-icon-danger, ".concat((0, $kLNLK.R500), ")")
    },
    success: {
        backgroundColor: "var(--ds-background-success, ".concat((0, $kLNLK.G50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($1pjMo))),
        primaryIconColor: "var(--ds-icon-success, ".concat((0, $kLNLK.G500), ")")
    },
    discovery: {
        backgroundColor: "var(--ds-background-discovery, ".concat((0, $kLNLK.P50), ")"),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($kjPIx))),
        primaryIconColor: "var(--ds-icon-discovery, ".concat((0, $kLNLK.P500), ")")
    }
};
function $0e87bee448892c08$export$e9b82d2e21ac0c1f(appearance, icon) {
    var appearanceIconStyles = $0e87bee448892c08$export$faa35441caff5bb6[appearance] || $0e87bee448892c08$export$faa35441caff5bb6.information;
    var AppearanceIcon = function AppearanceIcon(_ref) {
        var size = _ref.size, primaryColor = _ref.primaryColor, secondaryColor = _ref.secondaryColor;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91i6m))).createElement(appearanceIconStyles.Icon, {
            size: size,
            primaryColor: primaryColor,
            secondaryColor: secondaryColor,
            label: appearance
        });
    };
    var Icon = icon || AppearanceIcon;
    return $0e87bee448892c08$var$_objectSpread($0e87bee448892c08$var$_objectSpread({}, appearanceIconStyles), {}, {
        Icon: Icon
    });
}

});
parcelRegister("kjPIx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $03d140d28e37bc44$var$_react = $03d140d28e37bc44$var$_interopRequireDefault((parcelRequire("91i6m")));

var $6crSb = parcelRequire("6crSb");
function $03d140d28e37bc44$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $03d140d28e37bc44$var$QuestionCircleIcon = (props)=>/*#__PURE__*/ $03d140d28e37bc44$var$_react.default.createElement($6crSb.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="10"/><circle fill="inherit" cx="12" cy="18" r="1"/><path d="M15.89 9.05a3.975 3.975 0 00-2.957-2.942C10.321 5.514 8.017 7.446 8 9.95l.005.147a.992.992 0 00.982.904c.552 0 1-.447 1.002-.998a2.004 2.004 0 014.007-.002c0 1.102-.898 2-2.003 2H12a1 1 0 00-1 .987v2.014a1.001 1.001 0 002.004 0v-.782c0-.217.145-.399.35-.472A3.99 3.99 0 0015.89 9.05" fill="inherit"/></g></svg>`
    }, props));
$03d140d28e37bc44$var$QuestionCircleIcon.displayName = "QuestionCircleIcon";
var $03d140d28e37bc44$var$_default = $03d140d28e37bc44$var$QuestionCircleIcon;
module.exports.default = $03d140d28e37bc44$var$_default;

});




//# sourceMappingURL=VerifyEmailSentPage.7fa2b321.js.map
